import React, { useState } from "react";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { FadeUp } from "../components/Motion";
import { api, formatApiErrorDetail } from "../lib/api";

const empty = { name: "", email: "", subject: "", message: "" };

export default function Queries() {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill your name, email and message.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/queries", form);
      setDone(true);
      toast.success("Your query has been sent. We'll reply soon.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not submit. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader
        overline="Queries"
        title={["Ask us", "anything."]}
        subtitle="Have a question about a collection, a fitting, timelines or fabric? Send us a note and our team will get back to you."
      />
      <section className="max-w-[900px] mx-auto px-5 sm:px-8 pb-28">
        {done ? (
          <FadeUp>
            <div data-testid="query-success" className="border border-[#C6A15B] bg-white/60 rounded-sm p-12 text-center">
              <div className="w-16 h-16 rounded-full bg-[#C6A15B] text-[#121212] flex items-center justify-center mx-auto">
                <Check strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-3xl font-light mt-6">Message received.</h3>
              <p className="text-[#7a7568] mt-3">Thank you for reaching out. We'll respond shortly.</p>
              <button data-testid="new-query-btn" onClick={() => { setForm(empty); setDone(false); }} className="btn-outline mt-8 px-8 py-3 overline">
                <span>Send another</span>
              </button>
            </div>
          </FadeUp>
        ) : (
          <form data-testid="query-form" onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8">
            <label className="block"><span className="overline text-[#7a7568] block mb-2">Name *</span><input data-testid="query-name" className="field" value={form.name} onChange={set("name")} placeholder="Your name" /></label>
            <label className="block"><span className="overline text-[#7a7568] block mb-2">Email *</span><input data-testid="query-email" type="email" className="field" value={form.email} onChange={set("email")} placeholder="you@email.com" /></label>
            <label className="block sm:col-span-2"><span className="overline text-[#7a7568] block mb-2">Subject</span><input data-testid="query-subject" className="field" value={form.subject} onChange={set("subject")} placeholder="What is this about?" /></label>
            <label className="block sm:col-span-2"><span className="overline text-[#7a7568] block mb-2">Message *</span><textarea data-testid="query-message" rows={6} className="field resize-none" value={form.message} onChange={set("message")} placeholder="Write your query..." /></label>
            <div className="sm:col-span-2">
              <button data-testid="submit-query-btn" disabled={loading} className="btn-gold px-10 py-4 overline disabled:opacity-60">
                <span className="inline-flex items-center gap-2">{loading && <Loader2 size={16} className="animate-spin" />}{loading ? "Sending..." : "Send query"}</span>
              </button>
            </div>
          </form>
        )}
      </section>
    </>
  );
}
